import { SortOrder } from "sprint-common-web";

import { EpisodeListingItem } from "./EpisodeListingItem";

export interface EpisodeListingFilters {
    page: number;
    pageSize: number;
    sortBy: keyof EpisodeListingItem;
    sortOrder: SortOrder;
    orphanedOnly?: boolean;
    includeMerged?: boolean;
}

export const defaultEpisodeListingFilters: EpisodeListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "episodeNumber",
    sortOrder: "asc",
    orphanedOnly: false
};
